module.exports = {"audiences":["englishAndNewAndNoTeamsAndNoBoards"],"autoTrack":true,"experimentAllocation":0,"defaultWeight":1,"experimentVersion":"v2","defaults":{"enabled":false},"audienceSettings":{"startDate":"2019-02-21"},"variations":[{"name":"cardDragMadlibs","weight":0.5,"values":{}},{"name":"inlineInspirations","weight":0.5,"values":{}}]}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/onboarding.json
// module id = c7Lg
// module chunks = 24